import Button from"@wp/src/components/common/button";export const OnboardingNavigationButton=Button;